module.exports = __webpack_public_path__ + "static/media/caretDown.9bc59801.svg";